export const colors = ['#FB913A', '#4673D1', '#FF576D', '#8882D9', '#04A451'];
export const hoverColors = ['#E28234', '#3F68BC', '#ED4F64', '#7570B9', '#049440'];
